export const SUPPORTED_LOCALES_MAP = {
  english: 'en',
  frenchCanadian: 'fr-CA',
} as const;
export const SUPPORTED_LOCALES = Object.values(SUPPORTED_LOCALES_MAP);
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE = SUPPORTED_LOCALES_MAP.english;

export const isLocaleSupported = (locale: string): locale is SupportedLocale =>
  SUPPORTED_LOCALES.includes(locale as SupportedLocale);
